import { timerActions } from "../../../store/timerSlice"
import { UrlConstant } from "../../../urlConstant/UrlConstant"
import { useHttpRequest } from "../../../utils"
import useCallBack, { Callbacks } from "../../../utils/callback/useCallBack"

export const GetSingleTimeExpenseEntryMutation = <T>(id: string, callbacks?: Callbacks<T>) => {
    const { onError, onLoading } = useCallBack<any>(callbacks)

    const { getRequest } = useHttpRequest({})
    return async (dispatch: any) => {
        const getTimeExpenseEntries = async () => {
            try {
                const response = await getRequest(
                    `${UrlConstant.TimeExpenseEntry}/${UrlConstant.GetById}?id=${id}`
                )
                const data = await response
                return data
            } catch (error) {
                onError(error as Error)
            }
        }
        try {
            const res = await getTimeExpenseEntries()
            if (res) {
                dispatch(timerActions.getTimeEntry(res.data ?? {}))
            } else {
                dispatch(timerActions.getTimeEntry({}))
            }
        } catch (error) {
            onError(error as Error)
        } finally {
            onLoading(false)
        }
    }
}
